import React from 'react';
import './QRCode.css';

const QRCode = ({ imageUrl, label }) => {
  return (
    <div className="qr-container">
      <img src={imageUrl} alt="QR Code" className="qr-image" />
      <div className="qr-label">{label}</div>
    </div>
  );
};

export default QRCode;
